import React from 'react';
import PortfolioGalleryCommon from '../../layouts-components__common-cases/portfolio-gallery';
import './style.sass';

import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

const imgList = [
    '/images/pic/gens/gens-portfolio-img1.png',
    '/images/pic/gens/gens-portfolio-img2.png',
    '/images/pic/gens/gens-portfolio-img3.png',
    '/images/pic/gens/gens-portfolio-img4.png',
    '/images/pic/gens/gens-portfolio-img5.png',
    '/images/pic/gens/gens-portfolio-img6.png',
    '/images/pic/gens/gens-portfolio-img7.png',
    '/images/pic/gens/gens-portfolio-img8.png',
    '/images/pic/gens/gens-portfolio-img9.png',
    '/images/pic/gens/gens-portfolio-img10.png',
    '/images/pic/gens/gens-portfolio-img11.png',
    '/images/pic/gens/gens-portfolio-img12.png',
    '/images/pic/gens/gens-portfolio-img13.png',
    '/images/pic/gens/gens-portfolio-img14.png',
];

const PortfolioGallery = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={50} animateOnce={true} duration={1}>
            <PortfolioGalleryCommon
                imgList={imgList}
                className="gens-portfolio-gallery"
                isMargin={true}
                smallPaddings={true}
            />
        </ScrollAnimation>
    );
};

export default PortfolioGallery;
